module.exports = __webpack_public_path__ + "static/media/bubble-active-4.a07a23f2.svg";